var React = require('react');

function DisasterIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.191 7.887l14.543 12.816.133.133a.509.509 0 00.2.066v12.285c0 .31-.111.554-.333.731-.177.221-.42.332-.73.332H22.316l-2.656-3.652 6.906-4.25-9.828-9.098 3.985 7.902-6.907 4.25 2.457 4.848H6.38c-.31 0-.576-.11-.797-.332-.177-.177-.266-.42-.266-.73V20.901a.51.51 0 00.2-.066c.088-.044.132-.089.132-.133L20.191 7.887zm18.793 8.035c.532.487.554.996.067 1.527l-1.395 1.594c-.487.531-.996.553-1.527.066L20.922 5.695c-.487-.442-.974-.442-1.461 0L4.254 19.11c-.531.487-1.018.465-1.461-.066l-1.461-1.594c-.487-.531-.465-1.04.066-1.527l17-15.008A2.728 2.728 0 0120.191.25c.665 0 1.262.221 1.793.664l6.707 5.977V3.437c0-.31.089-.553.266-.73.221-.221.487-.332.797-.332h4.25c.31 0 .553.11.73.332.222.177.332.42.332.73v9.032l3.918 3.453z","fill":"#000"}));
}

DisasterIcon.defaultProps = {"width":"40","height":"35","fill":"#000"};

module.exports = DisasterIcon;

DisasterIcon.default = DisasterIcon;
